<table class="video-log-info-table table table-blue" *ngIf="videoLogService.videoLog">
    <tr>
        <th>County</th>
        <td>{{ videoLogService.videoLog?.countyName }} {{ videoLogService.videoLog?.countyCode }}</td>
    </tr>
    <tr>
        <th>Route</th>
        <td>{{ videoLogService.videoLog?.stateRouteNumber }} {{ videoLogService.videoLog?.routeName }}</td>
    </tr>
    <tr>
        <th>Type</th>
        <td>{{ jurisMap[videoLogService.videoLog?.juris] }}</td>
    </tr>
    <tr>
        <th>Direction</th>
        <td>{{ videoLogService.videoLog?.direction }}</td>
    </tr>
    <tr>
        <th>Segment</th>
        <td>{{ videoLogService.videoLog?.segmentNumber }}</td>
    </tr>
    <tr>
        <th>Offset / Segment Length</th>
        <td>{{ videoLogService.image?.offset }} ft. / {{ videoLogService.videoLog?.segmentLength }} ft.</td>
    </tr>
    <tr>
        <th>Latitude</th>
        <td>{{ videoLogService.image?.latitude }}</td>
    </tr>
    <tr>
        <th>Longitude</th>
        <td>{{ videoLogService.image?.longitude }}</td>
    </tr>
    <tr>
        <th>Name</th>
        <td>{{ (videoLogService.image?.imageName1 != videoLogService.image?.imageName2 || videoLogService.image?.imageName1 != videoLogService.image?.imageName3) ? videoLogService.image?.imageName3 + " | " + videoLogService.image?.imageName1 + " | " + videoLogService.image?.imageName2 : videoLogService.image?.imageName1 }}</td>
    </tr>
    <tr>
        <th>Date</th>
        <td>{{ videoLogService.image?.imageDate | date: 'MM/dd/yyyy' }}</td>
    </tr>
</table>
